const oAuthServiceConfig = {
  token: 'oauth2/token',
  authorize: `oauth2/authorize?response_type=code&client_id=${process.env.REACT_APP_OAUTH_CLIENT_NAME}&scope=openid&redirect_uri=`,
  clientId: 'client_id',
  redirectUri: 'redirect_uri',
  grantType: 'grant_type',
  grantTypeClientCredentials: 'client_credentials',
  code: 'code',
  codeVerifier: 'code_verifier',
  refreshToken: 'refresh_token',
  showrooms: 'api/showrooms',
  showroom: 'api/showroom',
  regions: 'api/regions',
  users: 'api/users',
  user: 'api/user',
  roles: 'api/roles',
  privileges: 'api/privileges',
  employeeInfo: 'api/employeeInformation',
  ports: 'api/ports',
  country: 'api/countries',
  role: 'api/roles',
  companies: 'api/companies',
  bankOptions: 'api/company/getNFZEBankDetails',
  receiptTypeOptions: 'receiptTypes?page=0&size=20',
  allTransactions: 'api/letterOfCredit/getAllLcTransactionForVoucher',
  allTransactionsOtherPayables: 'api/voucher/getAllocationForOtherPayable',
  activeCompanies: 'api/companies/search/findByActive',
  container: 'api/containers',
  company: 'api/company',
  territoryList: 'api/territories',
  territory: 'api/territories',
  customer: 'api/customers',
  region: 'api/regions',
  city: 'api/city',
  cities: 'api/cities',
  allCities: 'api/cities/allCities',
  factoryVendor: 'api/factoryVendors',
  factoryVendors: 'api/factoryVendor',
  priceGroup: 'api/priceGroups',
  material: 'api/material',
  orderCategories: 'api/orderCategories',
  shippingTypes: 'api/shippingTypes',
  shippingType: 'api/shippingType',
  salesBudget: 'api/salesBudget',
  holidays: 'api/hr/holidays',
  canias: 'api/canias',
  marketingBudget: 'api/marketing',
  euroStatCustomDS: "api/euroStat/euroStatCustomDS",
  deliveryTerms: 'api/deliveryTermses',
  // -----material-master------
  products: 'api/products',
  productsRangeVariation: 'api/material/getRangeVariation',
  findAllProduct: 'api/material/findProduct',
  ranges: 'api/ranges',
  rangeVariations: 'api/rangeVariations',
  addRangeVariations: 'api/material/saveRangeVariation',
  updateRangeVariations: 'api/material/updateRangeVariation',
  handles: 'api/handles',
  carcasses: 'api/carcasses',
  productBundles: 'api/productBundles',
  posMaterials: 'api/pOSMaterials',
  generics: 'api/generics',
  findRanges: 'api/material/findRanges',
  findRangeVariation: 'api/material/findRangeVariation',
  findAllCarcass: 'api/material/findAllCarcass',
  findHandles: 'api/material/findHandles',
  findProductBundle: 'api/material/findProductBundle',

  //-------resource-file-upload----
  fileUpload: 'api/files/uploadFile',
  fileDownload: 'api/files/downloadFile',

  budgetCategories: 'api/budgetCategories',

  //------hr-employee---------
  employees: "api/hr/employees",
  createEmployee: "api/hr/createEmployee",
  uploadMultipleFile: "api/files/uploadMultipleFile",
  uploadEductationDocument: "api/files/uploadMultipleFileForEdu",
  uploadFamilyDocument: "api/files/uploadMultipleFileForFamily",
  documentInfoes: "api/hr/documentInfoes",
  educationDocInfoes: "api/hr/educationDocInfoes",
  familyDocInfoes: "api/hr/familyDocInfoes",
  attendance: 'api/hr/attendanceInfoes',
  findAttendance: 'api/attendance/findAttendance',
  assets: "api/hr/assets",
  addnewasset: "api/assets/addnewasset",
  updateasset: "api/assets/updateasset",
  downloadAssetAttachment: "api/assets/getGridFsFile",
  assetType: "api/hr/assetTypes",
  empDocDownload: "/api/files/downloadFile",

  //--------save-grid-sate--------
  gridState: 'api/gridState',
  gridStates: 'api/gridStates',

  //---------Daily-Exchange-rate-----
  dailyExchangeRate: 'dailyExchangeRates',
  dailyExchange: 'dailyExchange',

  //--------Discount-Master-------
  discounts: 'api/discounts',

  //--------Transfer-Discount-------
  transferDiscounts: 'api/transferDiscounts',
  //--------Price Increase ----------
  priceIncrease:'api/priceIncreases',
  customerPriceIncrease:'api/customerPriceIncreases',
  vendorPriceIncrease:'api/vendorPriceIncreases',
  //--------German-Vat-------
  germanVats: 'api/germanVats',

  //-------Finance-------//
  chartOfAccount: 'api/chartOfAccount',
  chartOfAccount2s: 'chartOfAccount2s',
  financialYears: 'financialYears',
  financeYear: 'api/financeYear',
  paymentTerms: 'api/paymentTerms',
  statementOfAccount: 'api/statementOfAccount',
  ledgerBooksSearch: 'ledgerBooks/search',
  trialBalance: 'api/trialBalance',
  generateLedger: 'api/ledger',

  //--------OKR-performance----------
  performance: 'api/performance',
  oKRKeyResultses: 'api/hr/oKRKeyResultses',
  variableQuarter: 'api/hr/variableQuarters',
  okrs: 'api/hr/oKRs',

  //--------Company-info-finance-------
  companyInfoes: 'api/companyInfoes',
  companyInfo: 'api/companyInfo',

  //-------- Design Studio ----------
  displayMasters: 'api/designStudio/displayMasters',
  findRangeByVendor: 'api/ranges/search/findRangeByVendor',
  findAllHandlesByVendor: 'api/handles/search/findAllHandlesByVendor',
  findCarcassByVendor: 'api/carcasses/search/findByProductId',
  findAllCarcassByVendor: 'api/carcasses/search/findAllCarcassByVendor',
  dsTaskAssignments: 'api/designStudio/dsTaskAssignments',
  uploadMultipleFiles: 'api/designStudio/uploadMultipleFiles',
  downloadFile: 'api/designStudio/downloadFile',
  uploadFileForDisplayMaster: 'api/designStudio/uploadFileForDisplayMaster',
  spacePlanRevisions: 'api/designStudio/spacePlanRevisions',
  findTop20BySrNo: 'api/designStudio/spacePlanRevisions/search/findTop20BySrNo',
  dsTaskByPartnerId: 'api/designStudio/dsTaskAssignments/search/findByPartnerId',

  dsQuestionnaires: 'api/designStudio/dsQuestionnaires',
  dsTaskAssignment: 'api/designStudio/dsTaskAssignments',
  dsTaskList: 'api/designStudio/dsTaskAssignments',
  dsUploadMultipleFiles: 'api/designStudio/uploadMultipleFiles',
  dsFinddEvents: 'api/designStudio/findEvents',
  createCalendarDS: 'api/designStudio/createCalendarDS',

  // ------training-----
  trainingRequests: 'api/training/trainingRequests',
  trainersList: 'api/training/trainers',

  //--------hr-policies--------
  hrLibraryStructures: 'api/hr/libraryStructures',
  libraryStructure: 'api/libraryStructure',
  hrPolicyDocuments: 'api/hr/policyDocuments',
  policyLibrary: 'api/policyLibrary',

  //--------Order-routing--------
  orderRoutings: 'api/orderRoutings',
  getDashboardOrdersByCriteria: 'api/getDashboardOrdersByCriteria',
  lvDocumentInfoes: 'api/lvDocumentInfoes',

  //--------Account---------
  accountTypes: 'accountTypes',

  //--------vouchers--------
  voucherTypes: 'voucherTypes',
  voucherType: 'api/voucherType',
  voucher: 'api/voucher',
  voucherTransactions: 'api/voucherTransactions',
  currencies: 'currencies',

  //------Leave-management----
  leaveCategories: 'api/hr/leaveCategories',
  leave: 'api/leave',
  employementTypes: 'api/hr/employementTypes',
  leaveInfoes: 'api/hr/leaveInfoes',
  leaveEntitlements: 'api/hr/leaveEntitlements',

  //-----proforma-invoice-----
  paymentTerm: 'api/paymentTerm',

  //--------logistics----------------
  containers: 'api/containerPlan/getContainers',
  actualContainer: 'api/containers',
  containerPlans: 'api/containerPlans',
  containerPlan: 'api/containerPlan',
  nextAllowedContainerStatuses: 'api/nextAllowedContainerStatuses',
  containerUploadAttachement: 'api/containerPlan/uploadDocument',
  getContainerAttachment: 'api/containerPlan/getContainerAttachment',
  deleteDocument: 'api/containerPlan/deleteDocument',
  downloadAttachment: 'api/containerPlan/downloadFile',
  saveForwarderInfo: 'api/containerPlan/saveForwarderInfo',
  getForwarderInfo: 'api/containerPlan/getForwarderInfo',
  containerByShippingType: 'api/containerPlan/getContainerByShippingType',
  emailPreview: 'api/containerPlan/emailPreview',
  sendPreviewMail: 'api/containerPlan/sendPreviewMail',
  getReconciliationReport: 'api/pl/getreconciliationreport',
  hscode: 'api/hsCodes',
  orders: 'api/orders',
  getMyOrders: 'api/getmyorders',
  saveDeliveryInfo: 'api/deliveryInfo/saveDeliveryInfo',
  deliveryInfo: 'api/deliveryInfoes',
  findByKitchen: 'api/deliveryInfo/findByKitchenNamesAndOrderByDeliveryDates',
  generateInvoice: 'api/containerPlan/generateInvoice',
  deliveryInfoes: '/api/deliveryInfoes',
  getWeek: 'api/getweekfromdate',
  getDate: 'api/getdatefromweek',
  getDateFromyear: 'api/getmondaydatefromweekAndYear',
  addForwarderDetails: `/api/containerPlan/updateForwarder`,

  //-----paymentTerm-link-to-customer--
  paymentTermLinkToCustomers: 'api/paymentTermLinkToCustomers',

  //--------finance-invoice------------
  financeInvoice: 'api/containerPlan/getActualContainerNumber',

  //------letter-of-credit----
  letterOfCredit: 'api/letterOfCredit',
  letterOfCredits: 'letterOfCredits',
  lcDocuments: 'lCDocuments',
  lcDocument: "api/lcDocument",
  usances: "usances",
  bankInfoes: 'bankInfoes',

  bookingRequestMail: "api/bookingRequestMail",
  releaseRequestMail: "api/releaseRequestMail",
  getSequenceNumber: "api/getSequenceNumber",

  // -------Expense-Claims-------------//
  expenseClaimList: 'api/hr/expenses',
  expenseClaimConfig: 'api/hr/expenseClaimConfigs',
  expenseClaim: 'api/expenseClaim',

  // ------- Orders --------//
  newCustomerOrder: 'api/newcustomerorder',
  newCustomerProjectOrder: 'api/newCustomerProjectOrder',
  projectDraft: 'api/draftOrder',
  freightOptions: 'api/getOrderOptions',
  draftProjectByRole: `api/draftOrder/filterByRole`,
  uploadOrderFile: 'api/uploadOrderFile',
  downloadOrderFile: 'api/downloadOrderFile',
  getProjectForecastData: 'getProjectForecastData',
  searchOrderByAbNumber: 'api/searchOrderByAbNumber',
  searchOrderByCommissionName: 'api/searchOrderByCommissionName',
  searchProjectName: 'api/projects/search',
  newPartOrder: 'api/newPartOrder',
  newLinkOrder: 'api/linkAB',
  aoRoReasons: 'api/aoRoReasons',
  uploadPicture: 'api/uploadPicture',
  uploadAmendment: 'api/uploadAmendmentFile',
  getProjectByForecast: 'api/getProjectByForecast',
  getallhubspotdeals: 'api/deals/getallhubspotdeals',
  getPipelines:'/api/deals/getpipelines',
  orderHistories: 'api/orderHistories',
  OrderABFiles: 'api/orderABFiles',
  projectForecast: 'api/projectForecasts',
  standardDisc: 'api/getStandardDiscount',
  getNewOrderList: 'api/getNewOrderList',
  getOrdersForContainers: 'api/getOrdersForContainers',
  deleteFile: 'api/deleteFile',
  dashboardCount: 'api/getDashboardCountByCriteria',
  dashboardOrderCriteria: 'api/getDashboardOrdersByCriteria',
  unconfimedOrderCriteria: 'api/orders/search/findOrdersWithOrderConfirmedDateNotExists',
  nextAllowedOrderStatus: `api/nextAllowedOrderStatuses`,
  downloadOrderAbFiles: 'api/downloadAllAbFiles',

  //------ Reconciliation-------
  reconciliation: 'api/invoiceReconciliation',

  //------Proforma Invoice-------
  ProformaInvoice: 'api/invoice',
  ProformaInvoices: 'proformaInvoices',

  //------OSM-------------
  getOrdersByCriteria: 'api/getordersbycriteria',
  getOrdersForAOReport: 'api/get-ao-report-data',
  RestoreOrder: 'api/restore-orders',
  getordersbycriteriawithoutpaginated: 'api/getordersbycriteriapaginated?page=0&size=1000',
  findByCompanyId: 'api/containerPlans/search/findByCompanyId',
  calculateDiscount: 'api/calculateDiscount',
  getOrderListCalculation: 'api/getOrderListCalculation',
  changeOrderStatus: 'api/changeOrderStatus',
  orderWaitingSattus: 'api/setWaitingStatus',
  orderToMoveSpecialDiscount: "api/addOrdersToSpecialDiscount",

  //------absWithoutOrder-------------
  orderABFiles: '/api/orderABFiles/search/findByOrderDocumentNoNullOrderByCreatedDateDesc',


  //--------Op dashboard---------------
  getOrderCountByDocType: 'api/get-ordercount-by-doctype',
  getOrderCountByVendor: 'api/get-ordercount-by-vendor',
  getOrderCountByCategory: 'api/get-ordercount-by-category',
  getOrderCountByCategoryGroup: 'api/get-ordercount-by-categorygroup',
  getTerritoryOrderCountByCategoryGroup: 'api/get-territory-ordercount-by-categorygroup',
  getPartnerOrderCountByTerritory: 'api/get-partner-ordercount-by-territory',
  getMonthlyOrderCountByCategoryGroup: 'api/get-monthly-ordercount-by-categorygroup',
  findByTerritoryAndActiveTrueOrderById: 'api/companies/search/findByTerritoryAndActiveTrueOrderById',
  getTotalBudgetByCategoryGroup: 'api/get-total-budget',
  getTerritoryBudgetByYear: 'api/get-territory-budget',
  getCountryBudgetByYear: 'api/get-country-budgets',
  getLastBookingWeek: 'api/containerPlan/getLastBookingWeek',

  //------------Report Dashboard--------//
  getCustomerSalesByDateRange: 'api/get-customer-sales-by-date-range',
  getCustomerPurchasesByDateRange: 'api/get-customer-purchases-by-date-range',
  getCustomerBudgets: 'api/get-customer-budgets',
  findCompaniesByActiveAndType: 'api/companies/search/findByActiveAndCustomerType',
  getTerritoryExternalBudget: 'api/get-territory-external-budget',
  getTerritoryInternalBudget: 'api/get-territory-budget',
  getProjectTotal: 'api/get-project-totals'
}

export default oAuthServiceConfig;
